<!--*****************************************-->
<!--Animation examples-->
<!--https://dreambo8563.github.io/vue-particle-effect-buttons/-->
<!--https://github.com/chenxuan0000/svg-progress-bar-->
<!--https://tinymotion.me/#hover-->
<!--https://github.com/valgeirb/vue-confetti-explosion-->
<!--https://www.vuescript.com/confetti-animation-effect-vue-js/-->
<!--https://www.vuescript.com/3d-page-flip-effect-flipbook/-->
<!--*****************************************-->
<template>
  <div class="page noselect">
    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->
    <!--        </div> -->

    <!--        <h1 class="myTitle">Datenschutz</h1>-->

    <v-container grid-list-lg>
      <div class="spacer-15"></div>

      <StempelkarteBig></StempelkarteBig>

      <div class="text-left mt-7 mb-4">
        <div>
          <h4>Information</h4>
          Als <span class="text-decoration-underline pointer"
                    @click="goAccountOrSignin"
        >registrierter Nutzer</span> kannst du Stempel sammeln.
          Für jede 10 Euro Umsatz erhälst du einen Stempel.
          Bei 10 Stempel erhälst du {{ $store.getters.stempelRabattAmount }} Euro Rabatt auf die nächste Bestellung
          oder eine zukünftigen Bestellung deiner Wahl.
        </div>
      </div>

      <div class="mt-7 mb-6 text-center" v-if="!$store.getters.loggedIn">
        <div class="d-inline-block">
          <v-btn block
                 color="primary" rounded medium class="btn-df mb-3"
                 @click="$ebus.$emit('goto', {name:'Anmelden'})"
          >Zur Anmeldung
            <v-icon right medium>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn block
                 color="primary" rounded medium class="btn-df mt-3"
                 @click="$ebus.$emit('goto', {name:'Registrierung'})"
          >Zur Registrierung
            <v-icon right medium>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>

      <!--            <div class="mt-4"></div>-->

      <!--            <div class="rahmen">-->
      <!--                <v-layout row wrao>-->
      <!--                    <v-flex xs4 v-for="stempel in 10">-->
      <!--                        <div class="scontainer maxh">-->
      <!--                            <div class="superCenter" v-if="stempel <= stempelCounter">-->
      <!--                                <img class="stempelImage" src="../assets/loyalty/stempel.png">-->
      <!--                            </div>-->
      <!--                            <div class="superCenter" v-else>-->
      <!--                                <div class="circle"></div>-->
      <!--                            </div>-->
      <!--                        </div>-->
      <!--                    </v-flex>-->
      <!--                    <v-flex xs6>-->
      <!--                        <div class="maxh">-->
      <!--                            <div class="superCenter">-->
      <!--                                <div class="text-center">-->
      <!--                                    <div class="font-size:0.85em">..noch {{(100 - -->
      <!--                                        $store.getters.stempelkarte.punktestand)}} Punkte fehlen für-->
      <!--                                    </div>-->
      <!--                                    <h3 class="text-center">30 € Gutschein</h3>-->
      <!--                                </div>-->

      <!--                            </div>-->
      <!--                        </div>-->
      <!--                    </v-flex>-->
      <!--                </v-layout>-->
      <!--            </div>-->

      <div class="mt-4"></div>
      <!--            <v-layout row wrap>-->
      <!--                <v-flex xs7>-->
      <!--                    <v-btn class="btn-df okBtn text-none"-->
      <!--                           @click.native.passive="addPunkte(10)"-->
      <!--                    >-->
      <!--                        <v-icon left medium class="myWhite">-->
      <!--                            mdi-plus-circle-outline-->
      <!--                        </v-icon>-->
      <!--                        10 Punkte-->
      <!--                    </v-btn>-->
      <!--                </v-flex>-->
      <!--                &lt;!&ndash;                <v-flex xs5>&ndash;&gt;-->
      <!--                &lt;!&ndash;                    <v-btn class="btn-df grayBtn text-none"&ndash;&gt;-->
      <!--                &lt;!&ndash;                           @click.native.passive="reset"&ndash;&gt;-->
      <!--                &lt;!&ndash;                    >&ndash;&gt;-->
      <!--                &lt;!&ndash;                        Reset&ndash;&gt;-->
      <!--                &lt;!&ndash;                    </v-btn>&ndash;&gt;-->
      <!--                &lt;!&ndash;                </v-flex>&ndash;&gt;-->
      <!--            </v-layout>-->
    </v-container>


    <!--        <div class="fixWinner" v-if="showWinner">-->
    <!--            <v-container grid-list-lg>-->
    <!--                <v-layout row wrap>-->
    <!--                    <v-flex xs12>-->
    <!--                        <canvas id="confettiCanvas"></canvas>-->
    <!--                        <div class="scontainer maxh">-->
    <!--                            <div class="superCenter">-->
    <!--                                <div class="text-center">-->
    <!--                                    <h1 class="winnerText">Du hast einen 30 € Gutschein erhalten!</h1>-->
    <!--                                </div>-->
    <!--                            </div>-->
    <!--                        </div>-->
    <!--                    </v-flex>-->
    <!--                </v-layout>-->
    <!--            </v-container>-->
    <!--        </div>-->


  </div>
</template>

<script>
import {ebus} from '../vendor/ebus';
import store from '../store/store'
import * as util from "@/vendor/util";
import StempelkarteBig from "./StempelkarteBig.vue";

export default {
  components: {StempelkarteBig},
  data: () => ({
    showWinner: false,
  }),

  mounted() {
  },

  // activated() {
  //     util.jumpToTop(true);
  // },

  // deactivated() {
  //     // try {
  //     //     window.removeEventListener("message", this.processSizeUpdate);
  //     // } catch (e) {
  //     //     console.log('Error removing processSizeUpdate: ' + e.message);
  //     // }
  // },

  methods: {
    goAccountOrSignin() {
      if (this.$store.getters.loggedIn) {
        this.$router.push({name: 'Account'});
      } else {
        this.$router.push({name: 'Anmelden'});
      }
    },
    // addPunkte(x) {
    //     let r = store.getters.stempelkarte.punktestand;
    //     r = r + x;
    //     if (r >= 100) {
    //         r = 100;
    //     }
    //     store.commit('stempelkarte', {punktestand: r});
    //
    //     if (r === 100) {
    //         this.winningAnimation();
    //     }
    // },

    reset() {
      // store.getters.stempelkarte.punktestand = 35;
    },

    winningAnimation() {
      this.showWinner = true;
      this.showConfetti();
      setTimeout(() => {
        this.reset();
        this.showWinner = false
      }, 4500);
    },

    showConfetti() {
      // const canvas = document.getElementById('confettiCanvas');
      // const jsConfetti = new JSConfetti({canvas});
      // jsConfetti.addConfetti({
      //     emojis: ['✨', '🌯'],
      //     emojiSize: 25,
      //     confettiNumber: 60,
      // });
      //
      // jsConfetti.addConfetti();
      // setTimeout(() => {
      //     jsConfetti.addConfetti();
      // }, 900);
      // setTimeout(() => {
      //     jsConfetti.addConfetti();
      // }, 1800);

    },

  },
}
</script>

<style scoped lang="scss">

</style>
